import BarcodeIcon from "@/assets/icons/barcode.svg?react";
import NfcIcon from "@/assets/icons/nfc.svg?react";
import QrIcon from "@/assets/icons/qrcode.svg?react";
import UhfIcon from "@/assets/icons/uhf.svg?react";

const MARKER_TYPES = ["UHF", "NFC", "BAR", "QR"] as const;

type MarkerType = (typeof MARKER_TYPES)[number];

type MarkerConfig = {
  icon: React.ComponentType<{ className?: string }>;
  className: string;
  label: string;
};

const markerConfig: Record<MarkerType, MarkerConfig> = {
  BAR: {
    icon: BarcodeIcon,
    className: "border-emerald-300 bg-emerald-50 text-emerald-500",
    label: "Barcode",
  },
  QR: {
    icon: QrIcon,
    className: "border-cyan-300 bg-cyan-50 text-cyan-500",
    label: "QR Code",
  },
  NFC: {
    icon: NfcIcon,
    className: "border-blue-300 bg-blue-50 text-blue-500",
    label: "NFC",
  },
  UHF: {
    icon: UhfIcon,
    className: "border-violet-300 bg-violet-50 text-violet-500",
    label: "UHF RFID",
  },
};

export const MarkerChips = ({ matrix }: { matrix: string[] }) => (
  <div className="flex gap-2">
    {MARKER_TYPES.map((type) => {
      const active = matrix.some(
        (m) =>
          m.toUpperCase() === type ||
          (m.toUpperCase() === "BARCODE" && type === "BAR")
      );

      const Icon = markerConfig[type].icon;

      return (
        <div
          key={type}
          title={markerConfig[type].label}
          className={`flex h-6 w-6 items-center justify-center rounded border ${
            active
              ? markerConfig[type].className
              : "border-slate-300 bg-slate-50 text-slate-300"
          }`}
        >
          <Icon className="h-3 w-3 fill-current stroke-current" />
        </div>
      );
    })}
  </div>
);